export const ChangeIcon = () => (
  <svg
    width="32"
    height="33"
    viewBox="0 0 32 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect y="0.5" width="32" height="32" rx="16" fill="#E4EBA6" />
    <path
      d="M21.2567 14.8579V14.0361C21.2567 12.6744 20.1528 11.5706 18.7911 11.5706L10.5727 11.5706M13.0383 14.8579L10.332 12.1517C10.0111 11.8307 10.0111 11.3104 10.332 10.9894L13.0383 8.2832"
      stroke="#8B9447"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M10.7433 18.1421L10.7433 18.9639C10.7433 20.3256 11.8472 21.4294 13.2089 21.4294L21.4273 21.4294M18.9617 18.1421L21.668 20.8483C21.9889 21.1693 21.9889 21.6896 21.668 22.0106L18.9617 24.7168"
      stroke="#8B9447"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);
